import { render, staticRenderFns } from "./personaJuridicaLayout.vue?vue&type=template&id=0b69ebab"
import script from "./personaJuridicaLayout.vue?vue&type=script&lang=js"
export * from "./personaJuridicaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports